import { PhotoEvidenceGallery } from '../PhotoEvidenceGallery/PhotoEvidenceGallery';
import type { PhotoEvidenceItem } from '../PhotoEvidenceList/PhotoEvidenceList';

export type EvidenceSessionPhotoGalleryItem = PhotoEvidenceItem & {
  fullResolutionSrc: string;
  annotations?: { label: string; rgb_colour: number[]; segmentation: number[][] }[];
};

export const MAX_SESSION_EVIDENCE_PHOTOS = 10;
export const EvidenceSessionPhotoGallery = ({
  photoEvidence,
  maxImages = MAX_SESSION_EVIDENCE_PHOTOS,
  'data-testid': testId,
  handleClick,
}: {
  photoEvidence: EvidenceSessionPhotoGalleryItem[];
  maxImages?: number;
  'data-testid'?: string;
  handleClick?: (photo: PhotoEvidenceItem) => void;
}) => (
  <PhotoEvidenceGallery
    data-testid={testId}
    slotProps={{
      dialogGallery: {
        slotProps: {
          photoList: {
            evidencePhotos: photoEvidence.map((evidence) => ({
              src: evidence.fullResolutionSrc,
              thumbnailSrc: evidence.src,
              variant: evidence.variant,
            })),
          },
        },
      },
      inlineGallery: {
        evidencePhotos: photoEvidence.slice(0, maxImages).map((evidence) => ({
          src: evidence.fullResolutionSrc,
          thumbnailSrc: evidence.src,
          variant: evidence.variant,
        })),
        openOnClick: true,
        slotProps: {
          imageList: {
            cols: maxImages / 2,
          },
          resultIcon: { size: 'medium' },
        },
      },
    }}
    handleClick={handleClick}
  />
);
